<template>
  <div class="operator-account-oplog fadeInRight">
    <div class="title-box clearfix">
      <span class="m-title">运营商操作日志</span>
      <el-form inline class="right themed-form search-form" style="height: auto; line-height: 40px">
        <!-- <el-form-item label="运营商ID">
          <el-input v-model="query.accountId" placeholder="运营商ID"></el-input>
        </el-form-item> -->
        <el-form-item label="时间区间">
          <el-date-picker
            v-model="dateTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="onDateChange"
          />
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" class="themed-button" @click="onSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="content-box">
      <el-table
        ref="table"
        :data="tableData"
        stripe
        border
        :max-height="maxTableHeight"
        style="width: 100%"
        tooltip-effect="dark"
      >
        <el-table-column show-overflow-tooltip prop="accountId" label="运营商ID" min-width="180" />
        <el-table-column show-overflow-tooltip prop="accountName" label="运营商" min-width="160" />
        <el-table-column show-overflow-tooltip prop="category" label="类别" min-width="80" >
        <template slot-scope="scope">
          
            <span>{{ _getCategory(scope.row.category, 1) }}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="secondCategory" label="子类别" min-width="100" />
        <el-table-column show-overflow-tooltip prop="operation" label="操作" min-width="100" />
        <el-table-column show-overflow-tooltip prop="operatorName" label="操作人" min-width="120" />
        <el-table-column show-overflow-tooltip prop="operateTime" label="操作时间" min-width="170" />
        <el-table-column show-overflow-tooltip prop="pollParam" label="轮询参数" min-width="220" />
        <el-table-column show-overflow-tooltip prop="remark" label="备注" min-width="140" />
        <el-table-column show-overflow-tooltip prop="snapshotJson" label="原数据(snapshotJson)" min-width="260" />
      </el-table>

      <el-pagination
        :current-page.sync="pageNo"
        :page-sizes="[5, 10, 15, 50, 100, 1000]"
        :page-size="pageSize"
        style="text-align: left; margin-top: 20px"
        background
        layout="total,sizes,prev, pager, next,jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="onPageChange"
      />
    </div>
  </div>
</template>

<script>
import dictGroup from "@/mixins/dictGroup.js";
import resize from "@/mixins/resize.js";
import { getOperatorAccountOpLog } from "@/api/operatorManagement/operatorInterfaceList.js";

export default {
  name: "operatorAccountOpLog",
  mixins: [resize,dictGroup],
  data() {
    return {
      query: {
        accountId: "",
        startTime: "",
        endTime: "",
      },
      dateTime: [],
      pageNo: 1,
      pageSize: 15,
      total: 0,
      tableData: [],
    };
  },
  created() {
    const { accountId = "" } = this.$route.query || {};
    this.query.accountId = accountId;
    this.fetchList();
  },
  methods: {
    onDateChange(val) {
      if (val && val.length === 2) {
        this.query.startTime = val[0];
        this.query.endTime = val[1];
      } else {
        this.query.startTime = "";
        this.query.endTime = "";
      }
    },
    onSearch() {
      this.pageNo = 1;
      this.fetchList();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.fetchList();
    },
    onPageChange(page) {
      this.pageNo = page;
      this.fetchList();
    },
    fetchList() {
      const base = { pageNo: this.pageNo, pageSize: this.pageSize };
      const timeRange = { startTime: this.query.startTime, endTime: this.query.endTime };
      const params = Object.assign({}, base, timeRange, { accountId: this.query.accountId });
      getOperatorAccountOpLog(params).then((res) => {
        this.tableData = res.rows || [];
        this.total = res.total || 0;
      });
    },
  },
};
</script>

<style>
.operator-account-oplog .el-form-item__label {
  vertical-align: top;
}
</style>


